import React, { useState } from 'react'
import './LoginPage.css'
import backgroundImage from '../../Assets/background4.jpg'
import hostelLogo from '../../Assets/logo.png'
import gpay from '../../Assets/gpay.png'
import phonepe from '../../Assets/phonepe.png'
import paytm from '../../Assets/paytm.png'
import { useNavigate } from 'react-router-dom'
import { LoginAPI } from '../../AllAPI/AdminAPI'
import axios from 'axios'
import { toast } from 'react-toastify'
import { VscActivateBreakpoints } from 'react-icons/vsc'
import { AiFillBuild } from 'react-icons/ai'

export default function OfficeLoginPage({ onLogin }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!username.trim() || !password.trim()) {
      toast.error('Please enter both username and password')
      return
    }

    setLoading(true)

    try {
      const res = await axios.post(LoginAPI, {
        username: username,
        password: password,
      })

      const data = res.data
      setLoading(false)
      if (res.data == 'REQUIRED') {
        toast.warn('All fields required!')
      } else if (res.data == 'INVALID') {
        toast.warn('Invalid data!')
      } else if (res.data == 'ERROR') {
        toast.warn('ERROR!')
      } else if (res.data !== null) {
        const roleMap = {
          '0': 'superintendent',
          '1': 'admin',
          '2': 'warden',
          '3': 'office',
        }
        const roleName = roleMap[data.role] // convert 1→admin, 2→warden, 0→superintendent

        if (roleName !== 'office') {
          toast.error('You are not authorized to access Admin Login')
          return
        }

        sessionStorage.setItem('username', data.username)
        sessionStorage.setItem('branch_id', data.branch_id)
        sessionStorage.setItem('role', roleName)

        toast.success('Office login successful!')
        onLogin(roleName)
        navigate(`/${roleName}/login-year`, { replace: true })
      }
    } catch (error) {
      setLoading(false)
      toast.error('Something went wrong. Please try again.')
      console.error('Error:', error)
    }
  }

  return (
    <div
      className="login-background"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="row m-0">
        {/* TOP LEFT HEADER */}
        <div className="col-12">
          <div className="row m-0 p-0 align-items-center">
            <div className="col-3 col-md-2 col-xl-1 p-0">
              <img
                src={hostelLogo}
                alt="Company Logo"
                className="footer-logo"
              />
            </div>
            <div className="col-9 col-md-10 col-xl-11 p-md-0">
              <h6 style={{ color: '#eb3337' }}>
                {' '}
                Dakshin Bharat Jain Sabha's{' '}
              </h6>
              <h3
                style={{ textShadow: '1px 1px 2px #eb3337' }}
                className="company-name"
              >
                {' '}
                MANIKBAG DIGAMBAR JAIN BOARDING{' '}
              </h3>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="col-12 py-md-5">
          <div className="row p-3">
            <div className="col-12 col-md-6 col-xl-8"></div>
            <div className="col-12 col-md-6 col-xl-4 py-md-3 px-md-5">
              <div className="login-form-container">
                <div className="login-box pb-5">
                  <h2 className="login-title">Office Login</h2>
                  <form onSubmit={handleSubmit}>
                    <div className="input-group1">
                      <label>Username</label>
                      <input
                        type="text"
                        placeholder="Enter your username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        style={{ borderRadius: '4px' }}
                      />
                    </div>

                    <div className="input-group1">
                      <label>Password</label>
                      <input
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        style={{ borderRadius: '4px' }}
                      />
                    </div>

                    <button
                      type="submit"
                      className="login-btn"
                      disabled={loading}
                    >
                      {loading ? 'Logging in...' : 'Login'}
                    </button>
                  </form>

                  {/* <div className="bottom-links">
                    <span>
                      &copy; 2025 Jain Boarding | Managed By: TechnoAarv
                      Solution.
                    </span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="col-12">
          <footer className="footer row px-2 px-md-5">
            <div className="row m-0 p-0 footer-container">
              {/* LEFT */}
              <div className="col-12 col-md-6 footer-left">
                <div className="row m-0 p-0">
                  <div className="col-4 col-md-3 p-0">
                    <img
                      src={hostelLogo}
                      alt="Company Logo"
                      className="footer-logo"
                    />
                  </div>
                  <div className="col-8 col-md-9 p-0">
                    <h6 style={{ color: '#eb3337' }}>
                      {' '}
                      Dakshin Bharat Jain Sabha's{' '}
                    </h6>
                    <h3
                      style={{ textShadow: '1px 1px 2px #eb3337' }}
                      className="company-name"
                    >
                      {' '}
                      MANIKBAG DIGAMBAR JAIN BOARDING{' '}
                    </h3>
                  </div>
                </div>
              </div>

              {/* CENTER */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-center">
                <span
                  onClick={() => navigate('/terms')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Terms & Conditions
                </span>
                <span
                  onClick={() => navigate('/privacy')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Privacy Policy
                </span>
                <span
                  onClick={() => navigate('/student/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Student Login
                </span>
                <span
                  onClick={() => navigate('/office/login')}
                  style={{ cursor: 'pointer' }}
                >
                  <VscActivateBreakpoints style={{ color: 'orangered' }} />{' '}
                  Office Login
                </span>

                {/* <span>
                  <a href="upi://pay?pa=rohitpatilone0@oksbi&pn=Rohit Patil&am=500&cu=INR&tn=Payment For Testing">
                    <img
                      src={gpay}
                      alt="Google Pay"
                      className="shadow "
                      style={{ width: '30px', height: '30px' }}
                    />
                  </a>
                  <a href="phonepe://pay?pa=rohitpatilone0@oksbi&pn=Rohit Patil&am=500&cu=INR&tn=Payment For Testing">
                    <img
                      src={phonepe}
                      alt="PhonePe"
                      className="shadow "
                      style={{
                        width: '40px',
                        height: '40px',
                        marginLeft: '10px',
                      }}
                    />
                  </a>
                  <a href="paytmmp://pay?pa=rohitpatilone0@oksbi&pn=Rohit Patil&am=500&cu=INR&tn=Payment For Testing">
                    <img
                      src={paytm}
                      alt="Paytm"
                      className="shadow "
                      style={{
                        width: '50px',
                        height: '50px',
                        marginLeft: '10px',
                      }}
                    />
                  </a>
                </span> */}
              </div>

              {/* RIGHT */}
              <div className="col-12 col-md-3 mt-3 mt-md-0 footer-right">
                <h6 className="text-white pb-2">
                  Dakshin Bharat Jain Sabha's Manikbag Digambar Jain Boarding
                </h6>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Email: &nbsp;{' '}
                  <span>mdjbbelgavi@gmail.com</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Phone: &nbsp;{' '}
                  <span>7022691008 , 9480448108</span>
                </p>
                <p>
                  <AiFillBuild style={{ color: 'orangered' }} /> Address: &nbsp;
                  Opposite Manikbag Automobiles, Old P.B Road, Belagavi
                  Karnataka 590016
                </p>
              </div>
            </div>

            <div className="footer-bottom">
              © 2025 MANIKBAG DIGAMBAR JAIN BOARDING | Managed By TechnoAarv
              Solution
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}
